import React, { useEffect, useRef, useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import getIcon from '../../utils/getIcon';


const SelectDropdown = ({
  options = [],
  selectedOption = null,
  onSelectOption = () => {},
  className = '',
  defaultSelect = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [openUpwards, setOpenUpwards] = useState(false);
  const [localSelectedOption, setLocalSelectedOption] = useState(null);

  const dropdownRef = useRef(null);

  /* ----- 1. Mount anında defaultSelect varsa ayarla ----- */
  useEffect(() => {
    if (defaultSelect) {
      const def = options.find(
        (opt) => opt.value?.toString().toLowerCase() === defaultSelect.toString().toLowerCase()
      );
      if (def) setLocalSelectedOption(def);
    }
  }, [defaultSelect, options]);

  /* ----- 2. Parent’tan gelen seçili değer güncellenince senkronize et ----- */
  useEffect(() => {
    if (selectedOption) setLocalSelectedOption(selectedOption);
  }, [selectedOption]);

  /* ----- 3. Dışarı tıklama kapanışı ----- */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  /* ----- 4. Görünüm yukarı mı aşağı mı ----- */
  useEffect(() => {
    if (isOpen) {
      const rect = dropdownRef.current.getBoundingClientRect();
      setOpenUpwards(rect.bottom + 200 > window.innerHeight);
    }
  }, [isOpen]);

  /* ----- 5. Filtrelenmiş liste ----- */
  const filteredOptions = options.filter((o) =>
    o.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (opt) => {
    onSelectOption(opt);
    setLocalSelectedOption(opt);
    setIsOpen(false);
  };

  return (
    <div
      className={`select-dropdown ${className} ${openUpwards ? 'open-upwards' : ''}`}
      ref={dropdownRef}
    >
      {/* Seçili label */}
      <div className="select-box" onClick={() => setIsOpen((p) => !p)}>
        <span className="selected-label">
          {localSelectedOption?.color && (
            <span className="status-dot" style={{ background: localSelectedOption.color }} />
          )}
          {localSelectedOption?.icon && (
            <span className={`lh-1 fs-16 ${localSelectedOption.iconClassName}`}>
              {getIcon(localSelectedOption.icon)}{' '}
            </span>
          )}
          {localSelectedOption?.img && (
            <img src={localSelectedOption.img} className="avatar-image avatar-sm" />
          )}
          {localSelectedOption ? localSelectedOption.label : defaultSelect}
        </span>
        <span className="arrow">{isOpen ? <FiChevronUp /> : <FiChevronDown />}</span>
      </div>

      {/* Dropdown listesi */}
      {isOpen && (
        <div className="dropdown-list">
          <div className="search-input-outer">
            <input
              className="search-input"
              placeholder="Search…"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <ul>
            {filteredOptions.length ? (
              filteredOptions.map((o) => (
                <li
                  key={o.value}
                  className={o.value === localSelectedOption?.value ? 'active' : ''}
                  onClick={() => handleSelect(o)}
                >
                  {o.color && <span className="status-dot" style={{ background: o.color }} />}
                  {o.icon && (
                    <span className={`lh-1 me-3 fs-16 ${o.iconClassName}`}>
                      {getIcon(o.icon)}
                    </span>
                  )}
                  {o.img && <img src={o.img} className="avatar-image avatar-sm me-2" />}
                  {o.label}
                </li>
              ))
            ) : (
              <li className="no-result">No results found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SelectDropdown;
